import React from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";

interface ToggleSectionProps {
  id: string;
  label: React.ReactNode;
  description?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  children?: React.ReactNode;
  className?: string;
  /** When "indented", children will have a left border and padding */
  variant?: "default" | "indented";
  disabled?: boolean;
}

export const ToggleSection: React.FC<ToggleSectionProps> = ({
  id,
  label,
  description,
  checked,
  onCheckedChange,
  children,
  className,
  variant,
  disabled,
}) => (
  <div className={cn("space-y-3", className)}>
    <div className="flex items-center justify-between">
      <div className="pr-4">
        <Label htmlFor={id} className={cn("cursor-pointer text-foreground", disabled && "text-muted-foreground")}>
          {label}
        </Label>
        {description && (
          <p className={cn("text-xs text-muted-foreground", disabled && "opacity-60")}>
            {description}
          </p>
        )}
      </div>
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
      />
    </div>

    {checked && children && (
      <div className={cn(
        "animate-fade-in",
        variant === "indented" 
          ? cn(
              "pl-4 border-l-2 border-muted space-y-4 mt-2",
              "md:mt-4"
            )
          : "space-y-3"
      )}>
        {children}
      </div>
    )}
  </div>
);
